export default "__VITE_ASSET__CUp8oS4w__"